export enum AppThemeColors {
  primary = '#ff7c4f',
}

export default AppThemeColors
